import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconRefresh(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </Icon>
  )
}
